import { AgentMlsIdResource, NewAgentMlsIdResource } from "api/resource/agent-mls-id";

// The Set modal's POST body. A billable agent's new ID is added opted out when its Show on Featured Listings Page switch
// is off, so the first save keeps the admin's choice. Where the switch isn't offered, nothing opts out.
export const createBody = (agentId: number, boardId: number, mlsId: string, alternateId: string | null, togglable: boolean, show: boolean): NewAgentMlsIdResource => ({
	agentId,
	boardId,
	mlsId,
	optOut: togglable && !show,
	alternateId,
});

// The Edit modal's PUT body. Every PUT sends the whole Office MLS ID as it should be after the save (empty means none),
// pre-filled from the Featured row or the held value, so an untouched field keeps it. An office-sourced account's rows
// have none, so it sends null, which changes nothing on an office row. The opt-out flag changes only when the switch
// moved.
export const editBody = (entry: AgentMlsIdResource, mlsId: string, alternateId: string, office: boolean, moved: boolean, show: boolean): NewAgentMlsIdResource => ({
	agentId: entry.agentId,
	boardId: entry.boardId,
	mlsId,
	optOut: moved ? !show : entry.optOut,
	alternateId: office ? null : alternateId,
});
